// The admin shell (features/admin/routes.ts) owns the parent `feature-flags`
// path; this sub-feature only exposes the detail child segment so the shell can
// register `{ index, :name }` children. There is no absolute path constant —
// the detail container navigates relatively (`navigate(name)` / `navigate('..')`).
export const FEATURE_FLAG_DETAIL_SEGMENT = ':name'
